import React from 'react';
import { useStyletron } from 'baseui';
import { DataList, Loader } from 'commons-ui';
import { LIST_ENTITY_NAMES } from 'constant';

import useUserDeposits from './useUserWithdrawals';
import { columnConfigs } from './listConfig';
import DateRangeFilter from './DateRangeFilter';
import TextInputFilter from './TextInputFilter';

const UserWithdrawals: React.FC<{}> = () => {
	const { getUserWithdrawalsData, handleFilterSubmit, forceUpdate, showLoader } = useUserDeposits();

	const [css] = useStyletron();

	return (
		<>
			{showLoader && <Loader />}
			<div
				className={css({
					height: '60px',
					display: 'flex',
					alignItems: 'center',
					backgroundColor: 'white',
					paddingLeft: '10px',
					borderTop: '1px solid rgb(242, 242, 242)',
					gap: '100px'
				})}>
				<DateRangeFilter onSubmit={handleFilterSubmit} />
				<TextInputFilter onSubmit={handleFilterSubmit} />
			</div>
			<DataList
				fetchData={getUserWithdrawalsData}
				columnConfigs={columnConfigs}
				hideActions
				rowHeight={50}
				entity={LIST_ENTITY_NAMES.USER_WITHDRAWALS}
				globalForceUpdate={forceUpdate}
				height='calc(100vh - 220px)'
			/>
		</>
	);
};

export default UserWithdrawals;
